module.exports = __webpack_public_path__ + "img/poster (8).a0c3ccd4.jpg";